import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=78e4660b&"
import script from "./DeleteAccount.vue?vue&type=script&lang=js&"
export * from "./DeleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e4660b')) {
      api.createRecord('78e4660b', component.options)
    } else {
      api.reload('78e4660b', component.options)
    }
    module.hot.accept("./DeleteAccount.vue?vue&type=template&id=78e4660b&", function () {
      api.rerender('78e4660b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Account/Widgets/DeleteAccount.vue"
export default component.exports